import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { useDialogState } from "../../../../../hooks/useDialogState";
import { useTreeState } from "../../../../../hooks/useTreeState";
import { useAttributeState } from "../../../../../hooks/useAttributeState";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import ListItem from "@mui/material/ListItem";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Alert from "@mui/material/Alert";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TreeComponentTypeService from "../../../../../services/TreeComponentTypeService";
import {trackPromise} from "react-promise-tracker";
import http from "../../../../../shared/http-common";

import {useStylesDialog} from "../../../../../shared/useStyleDialog";

// Fenster zum Bearbeiten des ausgewählten Attributes

// Transition legt fest, wie das Fenster erscheint
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="left" ref={ref} {...props} />;
});

const GetUnitList = async (token, realm) => {
    const formData = new FormData();
    formData.append("realm", realm);
    return await http.post(`/componentType/getComponentTypeAttributeUnitList`, formData, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

const GetDatatypeList = async (token, realm) => {
    const formData = new FormData();
    formData.append("realm", realm);
    return await http.post(`/componentType/getComponentTypeAttributeDatatypeList`, formData, {
        headers: {
            "Content-Type": "application/json"
        }
    });
};

export default function UpdateAttrDialog({reloadTreeItem}) {

    const classesDialog = useStylesDialog();
    const dialog = useDialogState();
    const UpdateAttrDialogOpen = dialog.updateAttrOpen;
    const setUpdateAttrDialogOpen = dialog.setUpdateAttrOpen;
    const tree = useTreeState();
    const TreeSelected = tree.selected;
    const setTreeSelected = tree.setSelected;
    const TreeSelectedItem = tree.selectedItem;
    const setTreeItemsState = tree.setItems;
    const attr = useAttributeState();
    const setAttrIsSelected = attr.setIsSelected;
    const AttrSelected = attr.selected;
    const setAttrSelected = attr.setSelected;
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);
    const [AttrName, setAttrName] = useState(AttrSelected.name);
    const [AttrType, setAttrType] = useState(AttrSelected.attribute_type);
    const [AttrDataType, setAttrDataType] = useState(AttrSelected.data_type);
    const [AttrDesc, setAttrDesc] = useState(AttrSelected.description);
    const [AttrId, setAttrId] = useState(AttrSelected.attribute_id);
    const [AttrGlobalId, setAttrGlobalId] = useState(AttrSelected.global_id);
    const [AttrUnit, setAttrUnit] = useState(AttrSelected.unit);
    const [AttrUnitId, setAttrUnitId] = useState(AttrSelected.unit_id);
    const [AttrEnums, setAttrEnums] = useState(AttrSelected.enumeratorValues);

    const [alertOpen, setAlertOpen] = useState(false);
    const [unitList, setUnitList] = useState([]);
    const [datatypeList, setDatatypeList] = useState([]);
    const [enumEdit, setEnumEdit] = useState(false);

    useEffect(() => {
        setAttrName(AttrSelected.name);
        setAttrDataType(AttrSelected.data_type);
        setAttrEnums(AttrSelected.enumeratorValues);
        setAttrUnit(AttrSelected.unit);
        setAttrUnitId(AttrSelected.unit_id);
        setAttrDesc(AttrSelected.description);
        setAttrGlobalId(AttrSelected.global_id);
        setAttrId(AttrSelected.attribute_id);
        setAttrType(AttrSelected.attribute_type);
    }, [AttrSelected]);

    useEffect(() => {
        async function fetchLists() {
            try {
                const [unitResult, datatypeResult] = await Promise.all([
                    GetUnitList(token, realm),
                    GetDatatypeList(token, realm),
                ]);
                setUnitList(unitResult.data);
                setDatatypeList(datatypeResult.data);
            } catch (e) {
                console.error(e);
            }
        }
        fetchLists();
    }, [token, realm]);

    const updateAttr = (items) => {
        const updateArray = [];
        for (let y = 0; y <= items.length - 1; y++) {
            if (items[y].name !== AttrSelected.name) {
                updateArray.push(items[y].trim());
            }
        }
        updateArray.push({
            attribute_id: AttrId,
            name: AttrName.trim(),
            datatype: AttrDataType,
            attributeType: AttrType,
            unit: AttrUnit,
            unitId: AttrUnitId,
            enumerator: AttrEnums,
            description: AttrDesc.trim(),
            globalId: AttrGlobalId.trim()
        });
        return updateArray;
    };

    const Attr_Update = async () => {
        const updateArray = updateAttr(TreeSelectedItem);

        try {
            const data = {
                name: TreeSelected.name.trim(),
                description: TreeSelected.description.trim(),
                cafmId: TreeSelected.cafm_id.trim(),
                globalId: TreeSelected.global_id.trim(),
                code: TreeSelected.code.trim(),
                attributes: updateArray,
            };
            await trackPromise((async () => {
                await TreeComponentTypeService.saveComponentType(token, realm, data);
                const result = await TreeComponentTypeService.getTreeData(token, realm);
                setTreeItemsState(result.data);

                const newItem = await reloadTreeItem();
                if (newItem instanceof Array && newItem.length > 0) {
                    setTreeSelected(newItem[0]);
                    if (newItem[0].attribute) {
                        const found = newItem[0].attribute.find((a) => a.attribute_id === AttrId);
                        if (found) setAttrSelected(found);
                    }
                    setAttrIsSelected(true);
                }
            })());
        } catch (e) {
            console.error(e);
        }
    };

    const handleEnumChange2 = (event, index) => {
        const enumString = event.target.value;
        if (index === AttrEnums?.length) {
            event.target.value = '';
        }
        const bums = AttrEnums ? [...AttrEnums] : [];
        bums[index] = enumString;

        const newArray = [];
        bums.forEach(value => {
            if (value !== '') {
                newArray.push({ value, text: value });
            }
        });
        setAttrEnums(newArray);
    };

    const handleUnitChange = (val) => {
        setAttrUnitId(val.toString());
        setAttrUnit(val);
        if (!val) {
            setAttrUnit("");
        }
    };

    const lastEnumIndex = AttrEnums?.length;

    return (
        <div>
            <Dialog
                className={classesDialog.dialog}
                open={UpdateAttrDialogOpen}
                onClose={() => setUpdateAttrDialogOpen(false)}
                TransitionComponent={Transition}
                fullScreen
            >
                <AppBar className={classesDialog.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setUpdateAttrDialogOpen(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classesDialog.title}>
                            Merkmal <b> {AttrSelected.name} </b> bearbeiten
                        </Typography>
                        <Button
                            autoFocus
                            color="inherit"
                            onClick={() => {
                                setAlertOpen(true);
                            }}
                        >
                            Bestätigen
                        </Button>
                    </Toolbar>
                </AppBar>
                <List>
                    <ListItem>
                        <TextField
                            autoFocus
                            required
                            defaultValue={AttrSelected.name}
                            margin="dense"
                            id="Attr_name"
                            label="Name"
                            type="text"
                            fullWidth
                            onChange={(e) => setAttrName(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            autoFocus
                            required
                            defaultValue={AttrSelected.attribute_id}
                            margin="dense"
                            id="Attr_id"
                            label="Merkmal-ID"
                            type="text"
                            fullWidth
                            disabled
                            onChange={(e) => setAttrId(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <TextField
                            autoFocus
                            required
                            defaultValue={AttrSelected.global_id}
                            margin="dense"
                            id="Attr_globalid"
                            label="Global-ID"
                            type="text"
                            fullWidth
                            disabled
                            onChange={(e) => setAttrGlobalId(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <FormControl className={classesDialog.formControl}>
                            <InputLabel id="Attr_type_title">Typ</InputLabel>
                            <Select
                                labelId="Attr_type_title"
                                value={AttrDataType}
                                id="Attr_datatype"
                                required
                                fullWidth
                                onChange={(e) => setAttrDataType(e.target.value)}
                            >
                                <MenuItem value=""></MenuItem>
                                {datatypeList.map((item) => (
                                    <MenuItem key={item} value={item}>{item}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <InputLabel>Daten-Typ: {AttrDataType}</InputLabel>
                    </ListItem>
                    <ListItem>
                        <TextField
                            autoFocus
                            defaultValue={AttrSelected.description}
                            margin="dense"
                            id="Attr_description"
                            label="Beschreibung"
                            type="text"
                            fullWidth
                            onChange={(e) => setAttrDesc(e.target.value)}
                        />
                    </ListItem>
                    <ListItem>
                        <FormControl className={classesDialog.formControl}>
                            <InputLabel id="Attr_unit_title">Unit</InputLabel>
                            <Select
                                labelId="AttrUnitLabel"
                                value={AttrUnit}
                                id="Attr_unit"
                                onChange={(e) => handleUnitChange(e.target.value)}
                            >
                                <MenuItem value=""></MenuItem>
                                {unitList.map((item) => (
                                    <MenuItem key={item.code} value={item.code}>{item.name} [{item.code}]</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ListItem>
                    <ListItem>
                        <FormControl className={classesDialog.formControl}>
                            <InputLabel id="Attr_enumerator_label">Enumerator {AttrSelected?.enumerator}</InputLabel>
                            <Select
                                labelId="AttrEnumeratorLabel"
                                value=""
                                id="Attr_enumerator"
                                onChange={() => {}}
                            >
                                <MenuItem value=""></MenuItem>
                                {AttrEnums?.map((item) => (
                                    <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ListItem>
                    <Divider />
                </List>
            </Dialog>
            <Dialog
                open={alertOpen}
                className={classesDialog.dialogAlert}
                onClose={() => setAlertOpen(false)}
            >
                <AppBar className={classesDialog.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setAlertOpen(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classesDialog.title}>
                            Merkmal <b>{AttrSelected.name}</b> updaten
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <DialogContentText>{"Sind die Eingaben korrekt?"}</DialogContentText>
                    <Alert variant="outlined" severity="info">
                        <DialogContentText>Name: {AttrName}</DialogContentText>
                        <DialogContentText>Merkmal-ID: {AttrId}</DialogContentText>
                        <DialogContentText>Global-ID: {AttrGlobalId}</DialogContentText>
                        <DialogContentText>Data-Typ: {AttrDataType}</DialogContentText>
                        <DialogContentText>Typ: {AttrType}</DialogContentText>
                        <DialogContentText>Unit: {AttrUnit}</DialogContentText>
                        <DialogContentText>Enumeratoren: {AttrEnums}</DialogContentText>
                        <DialogContentText>Beschreibung: {AttrDesc}</DialogContentText>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAlertOpen(false)} color="primary">
                        Abbrechen
                    </Button>
                    <Button
                        onClick={async () => {
                            await Attr_Update();
                            setAlertOpen(false);
                            setUpdateAttrDialogOpen(false);
                        }}
                        color="primary"
                        autoFocus
                    >
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                className={classesDialog.dialogConfirm}
                open={enumEdit}
                onClose={() => setEnumEdit(false)}
                TransitionComponent={Transition}
            >
                <AppBar className={classesDialog.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => setEnumEdit(false)}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classesDialog.title}>
                            Enumerator bearbeiten für <b>{AttrName}</b>
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <div>
                        {AttrEnums?.map((item, index) => (
                            <TextField
                                key={index}
                                autoFocus
                                value={item.text}
                                defaultValue={item.text}
                                margin="dense"
                                id={`enum_${index}`}
                                label={`Enum-Wert ${index + 1}`}
                                type="text"
                                fullWidth
                                onChange={(e) => handleEnumChange2(e, index)}
                            />
                        ))}
                        <TextField
                            autoFocus
                            defaultValue=""
                            margin="dense"
                            id={`enum_${lastEnumIndex}`}
                            label={`Enum-Wert neu`}
                            type="text"
                            fullWidth
                            onChange={(e) => handleEnumChange2(e, lastEnumIndex)}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setEnumEdit(false);
                        }}
                        color="primary"
                    >
                        Abbrechen
                    </Button>
                    <Button
                        onClick={() => {
                            setEnumEdit(false);
                        }}
                        color="primary"
                    >
                        Bestätigen
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
